export default __webpack_public_path__ + "../staticImages/schinken-260.png";